import { Component, OnInit, ViewEncapsulation, signal } from '@angular/core';
import { ClientInformation } from '../../models/client-information';
import { ClientIntegrationService } from '../../services/client-integration.service';
import { Router } from '@angular/router';
import { User } from '../../models/user';
import { GridColumnData } from 'src/app/features/grid/classes/grid-column-data.class';
import { GridSettings } from 'src/app/features/grid/classes/grid-settings.model';

const _flatten = filter => {
  const filters = filter.filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? _flatten(curr) : [curr]), []);
  }
  return [];
};

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./clients.component.scss'],
  providers: [ClientIntegrationService],
  standalone: false,
})
export class ClientsComponent implements OnInit {
  // Constants
  type: 'numeric' | 'input' = 'input';
  allClients: ClientInformation[] = [];
  nonHiddenClients: ClientInformation[] = [];

  // Dynamic
  showHiddenClients = false;
  
  constructor(protected clientsUpdated: ClientIntegrationService, private router: Router, private user: User) {}

  public gridSettings = signal<GridSettings>(null);
  public gridLoading = signal<boolean>(true);
  settingsReady = false;

  ngOnInit(): void {
    this.setupGrid();
    this.clientsUpdated.getAllClients()
    .subscribe({
      next: (clients) => {
        this.allClients = clients;
        this.nonHiddenClients = this.allClients.filter(c => c.uiDisplay == true || c.uiDisplay == undefined);   
        this.gridLoading.set(false);  
        this.updateGrid();
      },
      error: (_error) => {
        this.gridLoading.set(false); 
        this.updateGrid();
      },
    });
  }

  setupGrid(): void {
    this.gridSettings.set(new GridSettings({
      data: [],
      loading: this.gridLoading,
      columns: [
        new GridColumnData({ field: 'losTalkerClientId', header: 'Client ID', width: '100px', minWidth: '50px'}),
        new GridColumnData({ field: 'clientDisplayName', header: 'Name', width: '300px', minWidth: '50px'}),
        new GridColumnData({ field: 'dataSourceTypeAgg', header: 'Data Source Types', width: '400px', minWidth: '50px'}),
        new GridColumnData({ field: 'compensafeInternalName', header: 'Short Name', width: '100px', minWidth: '50px'}),
        new GridColumnData({ field: 'clientInformationAliases', header: 'Aliases', width: '200px', minWidth: '50px'}),
      ],
      sortMode: 'multiple',
      multisort: [
        {
          field: 'clientDisplayName',
          order: 1,
        },
      ],
      dataKey: 'clientInformationId',
      export: {
        enabled: true,
        formats: ['csv'],
        fileName: 'Clients',
      },
      selection: {
        enabled: true,
        mode: 'single',
        selectionType: 'row',
      },
      actionColumn: {
        enabled: true,
        field: 'clientInformationId',
        usePrefix: true,
        prefix: 'editConfigV2',
      },
    }));
    this.settingsReady = true;
  }

  updateGrid(): void {
    this.gridSettings.set(new GridSettings({
      ...this.gridSettings(),
      data: this.showHiddenClients ? this.allClients : this.nonHiddenClients,
      loading: this.gridLoading,
    }));
  }

  handleSelectedRow = (selectedRows: any): void => {
    const selectedClient = selectedRows[0];
    
    if (this.checkAccess(['LOSTalker.Integration'])) {
      this.router.navigate(['/editConfigV2', selectedClient.clientInformationId]);
    }
  };

  checkAccess(role: string[]): boolean {
    if (this.user.checkAccess(role)) {
      return true;
    } else {
      return false;
    }
  }

  updateHiddenClientView(event: boolean) {
    if (this.user.checkAccess(['LOSTalker.Admin'])) {
      this.showHiddenClients = event;
      this.updateGrid();
    }
  }
}
